import { EvidenceStatus, EvidenceType } from '@seapoint/server/enums';
import { InvoiceEvidenceView } from '../../../types/entity-types';

export const getFilteredInvoiceEvidence = (evidence: InvoiceEvidenceView[], isReviewMatchLive: boolean) => {
  return evidence.filter((e) => {
    if (isReviewMatchLive) {
      if (
        ![EvidenceStatus.IS_PAID_PROCESSED, EvidenceStatus.COMPLETED].includes(e.status) ||
        e.type !== EvidenceType.INVOICE ||
        !e.invoiceDetails
      ) {
        return false;
      }
    } else {
      if (e.status !== 'IS_PAID_PROCESSED' || e.type !== EvidenceType.INVOICE || !e.invoiceDetails) {
        return false;
      }
    }

    if (!e.invoiceDetails.totalAmount || e.invoiceDetails.totalAmount <= 0) {
      return false;
    }

    return true;
  });
};
